import { createSlice } from '@reduxjs/toolkit';
import { processVideo, setVideoReady, saveVideoData } from "./api";

const initialState = {
    tracker: [],
    videoReady: null,
    savingVideo: false,
    savingVideoError: null,
    videoMap: {},  // Will store { videoName: videoId }
};

const videoSlice = createSlice({
    name: 'video',
    initialState,
    reducers: {
        setVideoTracker: (state, action) => {
            state.tracker = action.payload
        },
        initVideoReady: (state, action) => {
            state.videoReady = null
        },
        updateVideoMap: (state, action) => {
            state.videoMap = action.payload;
        },
        addVideo: (state, action) => {
            const { name, videoId } = action.payload;
            state.videoMap[name.toLowerCase()] = videoId;
        },
        removeVideo: (state, action) => {
            const { name } = action.payload;
            delete state.videoMap[name.toLowerCase()];
        },
    },
    extraReducers: {
        [processVideo.fulfilled]: (state, { payload }) => {
            console.log("processVideo.fulfilled")
        },
        [setVideoReady.fulfilled]: (state, { payload }) => {
            console.log("setVideoReady.fulfilled", payload)
            state.videoReady = payload
        },
        [saveVideoData.pending]: (state, { payload }) => {
            console.log("saveVideoData.pending")
            state.savingVideo = true;
        },
        [saveVideoData.rejected]: (state, { payload }) => {
            console.log("saveVideoData.rejected")
            state.savingVideo = false;
            state.savingVideoError = payload;
        },
        [saveVideoData.fulfilled]: (state, { payload }) => {
            console.log("saveVideoData.fulfilled")
            state.savingVideo = false;
        },
    }
});

const { actions, reducer } = videoSlice;

export const { setVideoTracker, initVideoReady, updateVideoMap, addVideo, removeVideo } = actions;
export default reducer;
